var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title-message-card"},_vm._l((_vm.items),function(item,i){return _c('div',{key:i},[_c('p',{class:item.titleClass},[_vm._v("\n            "+_vm._s(item.title)+"\n        ")]),_vm._v(" "),_c('p',{class:item.messageClass},[_vm._v("\n            "+_vm._s(item.message)+"\n        ")])])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5695a42e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/TitleMessageCard.vue
// module id = null
// module chunks = 